import blue from './blue/params'
import charcoal from './charcoal/params'
import darkgray from './darkgray/params'
import green from './green/params'
import gold from './gold/params'
import iceblue from './iceblue/params'
import porcelain from './porcelain/params'
import purple from './purple/params'

export const themes = {
    [blue.name]: blue,
    [charcoal.name]: charcoal,
    [darkgray.name]: darkgray,
    [green.name]: green,
    [gold.name]: gold,
    [iceblue.name]: iceblue,
    [porcelain.name]: porcelain,
    [purple.name]: purple
}
